<template>
  <v-combobox
    v-model="selectedCategories"
    append-outer-icon="refresh"
    chips
    clearable
    @click:append-outer="getCategories"
    deletable-chips
    :disabled="!selectedSellersWithPredictions.length"
    hide-details
    item-text="displayableText"
    item-value="url"
    :items="categoriesWithDisplayableText"
    label="Filtrar por categoría del seller"
    :loading="loadingCategoriesBySellers"
    multiple
    no-data-text="Al parecer no pudimos cargar las categorías"
    open-on-clear
    prepend-icon="category"
    small-chips
  >
    <!-- Customize the items in the selection list -->
    <template #item="{ item }">
      <span>{{ item.sellerName }} - {{ item.name }}</span>
    </template>
  </v-combobox>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "classifier"
);

/**
 * A component to set show the categories that contains predictions (it consumes them from the store)
 * and set the selected ones to use as filters.
 */
export default {
  computed: {
    ...mapState([
      "categoriesBySellers",
      "currentClassification",
      "getValidatedItems",
      "loadingCategoriesBySellers",
      "selectedCategoriesBySellers",
      "selectedSellersWithPredictions"
    ]),
    /**
     * Add a displayable text to the categories to use the power of the combobox's search.
     */
    categoriesWithDisplayableText() {
      return this.categoriesBySellers.map(category => ({
        ...category,
        displayableText: `${category.sellerName} ${category.name}`
      }));
    },
    /**
     * Map with the store the selected categories in the combobox.
     */
    selectedCategories: {
      get() {
        return this.selectedCategoriesBySellers;
      },
      set(categories) {
        this.setSelectedCategoriesBySellers(categories);
      }
    }
  },
  methods: {
    ...mapActions(["getCategoriesBySellers"]),
    ...mapMutations([
      "setCategoriesBySellers",
      "setSelectedCategoriesBySellers"
    ]),
    /**
     * Remove all the categories from the store with this function.
     */
    clearCategoriesBySellers() {
      this.setCategoriesBySellers([]);
    },
    /**
     * Get the categories to use in the combobox if there is no current category.
     */
    getCategories() {
      if (this.currentClassification && this.selectedSellersWithPredictions) {
        this.getCategoriesBySellers();
      }
    }
  },
  watch: {
    /**
     * Clear the categories if it changes the current classification.
     */
    currentClassification() {
      this.clearCategoriesBySellers();
    },
    /**
     * Clear the categories if we change to the validated view.
     */
    getValidatedItems() {
      this.clearCategoriesBySellers();
    }
  }
};
</script>